import { ajax } from '@/util/ajax'
import { Tool } from '@/util/tool'
import axios from 'axios'
const tool = new Tool()
const BASE_URL = '/gateway/platform-lmsapi'

const FilterApi = {
  getPortfolioList (success, failure) {
    return ajax.get(
      `${BASE_URL}/high-risk-filter/list-certain-portfolio`,
      null,
      success,
      failure
    )
  },
  getListRisk (input, success, failure) {
    return axios.get(
      `${BASE_URL}/high-risk-filter/list-risk-filter`, {
        params: {
          roleId: input.roleId
        },
        headers: {
          'Access-Token': input.token
        }
      }
    ).then(result => resultHandler(result, Promise.resolve, Promise.reject, success, failure))
  },
  // 修改和新增是一起的
  saveRiskFilter (input, success, failure) {
    return axios.post(
      `${BASE_URL}/high-risk-filter/save-risk-filter`, {
        roleId: input.roleId,
        filter: input.filter,
        operatedBy: input.operatedBy
      }, {
        headers: {
          'Access-Token': input.token
        }
      }
    ).then(result => resultHandler(result, Promise.resolve, Promise.reject, success, failure))
  },
  deleteRiskFilter (input, success, failure) {
    return axios({
      method: 'delete',
      url: `${BASE_URL}/high-risk-filter/delete-risk-filter/${input.id}`,
      params: {
        operatedBy: input.operatedBy
      },
      headers: {
        'Access-Token': input.token
      }
    }).then(result => resultHandler(result, Promise.resolve, Promise.reject, success, failure))
  },
  getListRiskFilterValue (input, success, failure) {
    return axios.get(
      `${BASE_URL}/high-risk-filter/list-risk-filter-value`, {
        params: {
          filterId: input.filterId,
          value: input.value
        },
        headers: {
          'Access-Token': input.token
        }
      }
    ).then(result => resultHandler(result, Promise.resolve, Promise.reject, success, failure))
  },
  saveRiskFilterValue (input, success, failure) {
    return axios.post(
      `${BASE_URL}/high-risk-filter/save-risk-filter-value`, {
        filterId: input.filterId,
        value: input.value,
        operatedBy: input.operatedBy
      },
      {
        headers: {
          'Access-Token': input.token
        }
      }
    ).then(result => resultHandler(result, Promise.resolve, Promise.reject, success, failure))
  },
  deleteRiskFilterValue (input, success, failure) {
    return axios({
      method: 'delete',
      url: `${BASE_URL}/high-risk-filter/delete-risk-filter-value/${input.id}`,
      params: {
        operatedBy: input.operatedBy
      },
      headers: {
        'Access-Token': input.token
      }
    }).then(result => resultHandler(result, Promise.resolve, Promise.reject, success, failure))
  },
  exportRiskFilterValue (token, input, success, failure) {
    return axios.post(
      `${BASE_URL}/high-risk-filter/export-risk-filter-value`, input,
      {
        headers: {
          'Access-Token': token,
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
    ).then(result => resultHandler(result, Promise.resolve, Promise.reject, success, failure))
  },
  importRiskFilterValue (token, input, success, failure) {
    return axios.post(
      `${BASE_URL}/high-risk-filter/import-risk-filter-value`, input,
      {
        headers: {
          'Access-Token': token,
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
    ).then(result => resultHandler(result, Promise.resolve, Promise.reject, success, failure))
  }
}

function resultHandler (result, resolve, reject, success, failure) {
  if (tool.isNotEmpty(result)) {
    const resultData = result.data

    if (result.status === 200) {
      if (resultData.code < 0) {
        if (failure) {
          failure(resultData)
        }

        return Promise.reject(result.data).catch(function (reason) {
        })
      } else {
        if (success) {
          success(resultData.data)
        }

        return Promise.resolve(resultData.data)
      }
    } else {
      if (failure) {
        failure(resultData)
      }

      return Promise.reject(result.statusText)
    }
  } else {
    return Promise.reject(new Error('')).catch((e) => {})
  }
}

export { FilterApi }
